
import React, { createContext, useContext, useEffect, useState } from 'react';
import { chatStore } from 'services/ChatStore';
import ChatService from 'services/chatService'; // Keep for user info helper

const ChatContext = createContext(null);

export const ChatProvider = ({ children }) => {
  const [chatState, setChatState] = useState(chatStore.state);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    // Sync React state with Store
    const unsubscribe = chatStore.subscribe((newState) => {
      setChatState({ ...newState });
    });

    // Load current user info
    try {
      const user = ChatService.getCurrentUserInfo();
      setCurrentUser(user);
    } catch (e) {
      console.warn("ChatProvider: No user logged in");
    }

    return () => unsubscribe();
  }, []);

  const sendMessage = (chatId, text, receiverType) => {
    if (!currentUser) return;

    // Construct sender info based on current user
    const senderInfo = {
      id: currentUser.userId,
      type: currentUser.userType,
      name: currentUser.userName
    };

    // Send to API
    try {
      if (currentUser.userType === 'admin') {
        ChatService.sendMessage(currentUser.userId, 'admin', parseInt(chatId), receiverType, text);
      } else {
        ChatService.sendMessage(currentUser.userId, currentUser.userType, 1, 'admin', text);
      }
    } catch (error) {
      console.error('Failed to send message to API:', error);
      // Still add to local store for UI feedback
    }

    chatStore.sendMessage(chatId, text, senderInfo);
  };

  const receiveMessage = (chatId, text, senderInfo) => {
    chatStore.receiveMessage(chatId, text, senderInfo);
  };

  const openChat = (chatId) => {
    chatStore.openChat(chatId);
  };

  const syncMessages = (chatId, messages) => {
    chatStore.syncMessages(chatId, messages);
  };

  const closeChat = () => {
    chatStore.closeChat();
  };

  const getBadgeCount = (chatId) => {
    return chatStore.getUnseenCount(chatId);
  };

  return (
    <ChatContext.Provider value={{
      chatState,
      sendMessage,
      receiveMessage,
      syncMessages,
      openChat,
      closeChat,
      getBadgeCount,
      currentUser
    }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};
